import { ColumnType } from './Table.component'
import { TableHeaderCell, TableHeaderRow } from './Table.styles'

interface TableHeaderProps<T> {
  columns: ColumnType<T>[]
  enableSelection?: boolean
  selectAllChecked?: boolean
  onSelectAll?: () => void
}

export function TableHeader<T>({
  columns,
  enableSelection = false,
  selectAllChecked = false,
  onSelectAll,
}: TableHeaderProps<T>) {
  return (
    <TableHeaderRow>
      {enableSelection && (
        <TableHeaderCell style={{ width: '40px', paddingRight: '8px', paddingLeft: '8px' }}>
          <input type="checkbox" checked={selectAllChecked} onChange={onSelectAll} style={{ cursor: 'pointer' }} />
        </TableHeaderCell>
      )}
      {columns.map((column) => (
        <TableHeaderCell
          key={column.key}
          style={{
            width: column.width ? `${column.width}px` : 'auto',
            textAlign: column.align || 'left',
          }}>
          {column.title}
        </TableHeaderCell>
      ))}
    </TableHeaderRow>
  )
}
